<template>
  <div class="timer-slideshow">
    <div
      class="timer-slideshow_left"
      :class="{ 'timer-slideshow_left_mobile': smallScreen }"
    >
      <div
        v-for="item in features"
        :key="item.id"
        class="timer-slideshow_item"
        @click="switchFeature(item)"
      >
        <div class="timer-slideshow_item_title mt-2">
          <!-- :class="{ 'clr-primary': index === item.id }" -->
          {{ item.title }}
        </div>
        <div
          v-if="smallScreen"
          class="timer-slideshow_item_subtitle"
        >
          {{ item.subtitle }}
        </div>
        <div
          v-if="!smallScreen"
          class="timer-slideshow_item_progress"
          :class="{ active: slideshowIndex === item.id }"
        ></div>
        <div
          v-else
          class="timer-slideshow_item_img mt-2"
        >
          <img :src="getImage(item.img)" />
          <!-- <div class="timer-slideshow_item_subtitle">{{ item.subtitle }}</div> -->
        </div>
      </div>
    </div>

    <div
      v-if="!smallScreen"
      class="timer-slideshow_right anim-fade-in"
    >
      <transition-group
        name="fade"
        mode="out-in"
        class="d-flex flex-1"
        tag="div"
      >
        <div
          v-for="(item, idx) in features"
          v-show="idx === slideshowIndex"
          :key="item.id"
          class="timer-slideshow_right_img"
        >
          <img :src="getImage(item.img)" />
          <div
            v-if="!smallScreen"
            class="pt-2 weight_500 text-center w-100 text-medium clr-grey"
          >
            {{ item.subtitle }}
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimerSlideshow',
  props: {
    features: Array,
  },
  data() {
    return {
      intervalID: 0,
      time: 5000,
      slideshowIndex: 0,
    }
  },
  created() {
    this.startSlideshow()
  },
  beforeUnmount() {
    clearInterval(this.intervalID)
  },
  methods: {
    switchFeature(feature) {
      clearInterval(this.intervalID)
      this.slideshowIndex = feature.id
      this.startSlideshow()
    },
    startSlideshow() {
      this.intervalID = setInterval(() => {
        const index = this.slideshowIndex + 1
        this.slideshowIndex = index > this.features.length - 1 ? 0 : index
      }, this.time)
    },
    getImage(img) {
      return new URL(`/src/assets/img/${img}`, import.meta.url).href
    },
  },
  computed: {
    user_info() {
      const { user_info } = this.$store.getters
      return user_info
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
  },
}
</script>

<style lang="scss" scoped>
.timer-slideshow {
  display: flex;
  min-height: 23rem;
  width: 100%;
  &_left {
    display: flex;
    flex-direction: column;
    min-width: 40%;
    &_mobile {
      width: 100%;
    }
  }
  &_right {
    min-width: 60%;
    padding: 1rem 2rem;
    display: flex;
    position: relative;
    &_img {
      img {
        width: 100%;
        flex: 1;
        height: 100%;
        border-radius: 8px;
      }
      position: absolute;
    }
  }
  &_item {
    display: flex;
    flex-direction: column;
    transition: 0.3s;
    // padding: 1rem;
    border-radius: 8px;
    margin: 1rem 0 0 0;
    &:hover {
      cursor: pointer;
      // background: var(--clr-black-2);
      transform: scale(1.025);
    }
    &_title {
      font-size: 1.25rem;
      font-weight: 700;
    }
    // &_subtitle {
    // }
    &_progress {
      background: var(--clr-black-3);
      height: 4px;
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      margin: 0.5rem 0 0 0;
    }
    &_progress.active {
      &:before {
        content: '';
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
        border-radius: 4px;
        height: 100%;
        width: 100%;
        background: var(--clr-black-0);
        background: var(--clr-primary);
        animation: FillMe 5s infinite;
      }
    }
    &_img {
      img {
        height: 100%;
        width: 100%;
        border-radius: 8px;
      }
    }
  }
}
@keyframes FillMe {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
</style>
